import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Blocker } from 'react-router';

interface IConfirmNavigationDialog {
  open: boolean;
  handleClose: () => void;
  data: {
    handleSubmit?: (this: Window, ev: SubmitEvent) => any;
    handleDiscardAndProceed: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    blocker: Blocker;
  };
}

export const ConfirmNavigationDialog = ({ open, handleClose, data }: IConfirmNavigationDialog) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      onClose={() => {
        data.blocker?.reset?.();
        handleClose();
      }}
    >
      <DialogTitle>Please Confirm</DialogTitle>

      <DialogContent>
        <Typography variant="body1">You have unsaved data changes. Do you want to proceed?</Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={() => handleClose()}>
          Cancel
        </Button>

        <Button variant="contained" color="primary" type="submit" onClick={data.handleDiscardAndProceed}>
          Discard & Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmNavigationDialog;
